import React from "react";

import { AssetsCollectionProvider } from "../../contexts/assetsCollection";
import { useAssetsFilterVariables } from "../../hooks/capture/useAssetsFilterVariables";
import { useCapture } from "../../contexts/capture";

export default function CollectionProvider({ type, variables = {}, skipQuery = false, children }) {
  const { order } = useCapture();
  const assetsVariables = useAssetsFilterVariables(order);
  const mergedVariables = { ...assetsVariables, ...variables };

  return (
    <AssetsCollectionProvider type={type} variables={mergedVariables} skipQuery={skipQuery}>
      {children}
    </AssetsCollectionProvider>
  );
}
